export default "__VITE_ASSET__BVpvKzyF__"